define(['components/utilities/utilities', 'components/pubsub/pubsub'], function (utils, pubsub) {
	'use strict';

	/**
	 * Autosubmit
	 * A plugin that adds autosubmit functionality..
	 * @version 1.0.0
	 * @exports autoSubmit
	 */
	var autoSubmit = {

		/**
		 * The initialization function for this module.
		 * @public
		 */
		init: function () {
			this._initAutosubmit();
			this._initSubscriptions();
		},


		/**
		 * Function that initiates the autosubmit functionality.
		 * This can be used on an input to have it to submit the form on change.
		 * @private
		 */
		_initAutosubmit: function () {
			utils.forEachElement('[data-type="autosubmit"]', function (el) {
				if (el.getAttribute('data-initiated') !== null) {
					return false;
				}

				el.setAttribute('data-initiated', true);

				utils.addEventListener(el, 'change', function () {
					var form = el.form;

					if (form !== null) {
						utils.triggerEvent(form, 'submit');
					}
				});
			});
		},


		/**
		 * Initiates subscriptions.
		 * @private
		 */
		_initSubscriptions: function () {
			pubsub.subscribe('/ajaxForm/sync/updated', this._initAutosubmit);
		}
	};


	return autoSubmit;
});


//////////////////
// WEBPACK FOOTER
// ./components/autoSubmit/autoSubmit.js
// module id = 8
// module chunks = 0